"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PremiumImageBanner;
const react_1 = __importDefault(require("react"));
const PremiumImageBanner_module_scss_1 = __importDefault(require("./PremiumImageBanner.module.scss"));
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
const buildImageUrl_1 = require("../../../utils/buildImageUrl");
function PremiumImageBanner({ ctaLink, clickUrl, impressionUrl, associatedAdvertId, desktopImage, accessibilityText, esiType, }) {
    const xlSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, { wid: "1263", sm: "aspect", aspect: "1263:145", fmt: "auto" }, { applyPoi: true });
    const xlSrc2x = (0, buildImageUrl_1.buildImageUrl)(desktopImage, { wid: "2526", sm: "aspect", aspect: "1263:145", fmt: "auto" }, { applyPoi: true });
    const lgSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, { wid: "941", sm: "aspect", aspect: "941:145", fmt: "auto" }, { applyPoi: true });
    const lgSrc2x = (0, buildImageUrl_1.buildImageUrl)(desktopImage, { wid: "1882", sm: "aspect", aspect: "941:145", fmt: "auto" }, { applyPoi: true });
    return (react_1.default.createElement("a", { href: ctaLink, className: PremiumImageBanner_module_scss_1.default.bannerLink, "data-testid": "nav-flyout-premium-image-banner-link", onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
                esiType,
            });
        } },
        react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { media: "(min-width: 1440px)", srcSet: `${xlSrc} 1x, ${xlSrc2x} 2x` }),
            react_1.default.createElement("source", { media: "(min-width: 1280px)", srcSet: `${lgSrc} 1x, ${lgSrc2x} 2x` }),
            react_1.default.createElement("img", { "data-testid": "nav-flyout-premium-image-banner-image", src: lgSrc, className: PremiumImageBanner_module_scss_1.default.bannerImage, alt: accessibilityText }))));
}
